import { FollowItemInfo, Sets } from "@/types/mySpace";
import React, { useState } from "react";
import { useHistory } from "react-router";
import formatDate from "../../utils";
import styles from "./index.module.scss";

interface IFollowItem {
  info: FollowItemInfo;
  handleFollow: (userId: number | string) => void;
  handleCancelFollow: (userId: number | string) => void;
}

const IMG_COMPRESSION_W = 150;

const FollowItem: React.FC<IFollowItem> = ({ info, handleFollow, handleCancelFollow }) => {
  const { avatar, nickname, pubtime, user_id, describes } = info;
  const history = useHistory();
  const [localFollow, setLocalFollow] = useState<boolean>(true); // 默认是关注状态
  const followBtnClicked = () => {
    setLocalFollow(true);
    handleFollow(user_id);
  };

  const cancelFollowClicked = () => {
    setLocalFollow(false);
    handleCancelFollow(user_id);
  };

  const avatarClicked = () => {
    // history.push(`/artists/${user_id}`);
    window.open(`/artists/${user_id}`, "_blank");
  };

  return (
    <div className={styles["follow-item-wrapper"]}>
      <div className={styles["item-img-wrapper"]} onClick={avatarClicked}>
        <img src={`${avatar}?x-oss-process=image/resize,w_${IMG_COMPRESSION_W}`} alt="" />
      </div>
      <div className={styles["name-wrapper"]}>{nickname}</div>
      <div className={styles["describe-wrapper"]}>{describes}</div>
      <div className={styles["pub-time-wrapper"]}>{`最新发布: ${formatDate(
        new Date(Number(pubtime) * 1000),
        "YYYY-MM-DD",
      )}`}</div>
      {localFollow ? (
        <button className={`${styles["follow-btn"]}`} onClick={cancelFollowClicked}>
          已关注
        </button>
      ) : (
        <button
          className={`${styles["follow-btn"]} ${styles["dangerous"]}`}
          onClick={followBtnClicked}
        >
          + 关注
        </button>
      )}
    </div>
  );
};

export default FollowItem;
